import PropTypes from 'prop-types';
import React from 'react';
import { Range, Direction } from 'react-range';

import StyledRangeSlider from './rangeSlider.style';

const RangeSlider = ({
  values = [0],
  onChange = () => {},
  min = 0,
  max = 100,
  step = 10,
  vertical = false,
  ...componentProps
}) => {
  return (
    <StyledRangeSlider {...componentProps} vertical={vertical} min={min} max={max} values={values}>
      <Range
        direction={vertical ? Direction.Up : Direction.Right}
        step={step}
        min={min}
        max={max}
        values={values}
        onChange={arr => onChange(arr)}
        renderTrack={({ props, children }) => (
          <div {...props} className="rangeSlider__track" style={{ ...props.style }}>
            {children}
          </div>
        )}
        renderThumb={({ props }) => (
          <div {...props} className="rangeSlider__thumb" style={{ ...props.style }} />
        )}
      />
    </StyledRangeSlider>
  );
};

RangeSlider.propTypes = {
  values: PropTypes.arrayOf([PropTypes.number]),
  onChange: PropTypes.func,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  vertical: PropTypes.bool
};

export default RangeSlider;
